export default __webpack_public_path__ + "static/media/inquiry-icon.d1fe0d74.svg";